import { ListProp } from "../../constants/props";
import styles from "../../constants/styles";
import { ReactComponent as Checkmark } from "../../assets/checkmark.svg";

const CheckedList = ({ values }: ListProp) => {
  return (
    <ol className="list-decimal list-inside">
      {values.map(value => {
        return (
          <div key={value} className="flex flew-row">
            <svg className="w-6 h-6">
              <Checkmark />
            </svg>
            <span className={styles.standardText}>{value}</span>
          </div>
        );
      })}
    </ol>
  );
};

export default CheckedList;
